export enum Permission {
  SiteManagement = 'site_management.modify',
  LegacyAdmin = 'admin_panel.legacy_permission',
  ReadOnly = 'revoke_writes.legacy_permission',
  StoreConfigsView = 'store_configs.view',
  StoreConfigsModify = 'store_configs.modify',
  StorefrontNavigationView = 'storefront_navigation.view',
  StorefrontNavigationModify = 'storefront_navigation.modify',
}
